import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const EVENT_TIMEZONE = "Asia/Tokyo";
const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

export const toJSTDayjs = (dateStr: string | Date): dayjs.Dayjs => {
	return dayjs(dateStr).tz(EVENT_TIMEZONE);
};

export const getJSTHours = (dateStr: string | Date): number => {
	const date = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
	return new Date(date.getTime() + JST_OFFSET_MS).getUTCHours();
};

export const getJSTMinutes = (dateStr: string | Date): number => {
	const date = typeof dateStr === "string" ? new Date(dateStr) : dateStr;
	return new Date(date.getTime() + JST_OFFSET_MS).getUTCMinutes();
};

export const isSameDayJST = (
	occurrenceDate: string | Date,
	calendarDate: Date,
): boolean => {
	const date =
		typeof occurrenceDate === "string"
			? new Date(occurrenceDate)
			: occurrenceDate;
	const jstDate = new Date(date.getTime() + JST_OFFSET_MS);
	return (
		jstDate.getUTCFullYear() === calendarDate.getFullYear() &&
		jstDate.getUTCMonth() === calendarDate.getMonth() &&
		jstDate.getUTCDate() === calendarDate.getDate()
	);
};

export const createJSTISOString = (
	calendarDate: Date,
	hour: number,
	minute: number,
): string => {
	const year = calendarDate.getFullYear();
	const month = calendarDate.getMonth();
	const day = calendarDate.getDate();
	return new Date(
		Date.UTC(year, month, day, hour - 9, minute, 0, 0),
	).toISOString();
};
